module.exports = __webpack_public_path__ + "img/2.2.1a8142e4.png";